module.exports = __webpack_public_path__ + "static/photo-profil-18004ecddc006feb8bbb66bdf390560a.jpg";